import React from 'react';
import { SvgIcon } from './utils/SvgIcon.js';
import type { SvgIconT } from './utils/react-desc-prop-types.js';

const QuickOrder = (props: SvgIconT.Props) => (
  <SvgIcon width={24} height={24} {...props} viewBox="0 0 24 24">
    <path
      d="M14.02 3c4.963 0 9 4.037 9 9s-4.037 9-9 9a8.94 8.94 0 0 1-6.374-2.647.5.5 0 1 1 .708-.706A7.95 7.95 0 0 0 14.02 20c4.411 0 8-3.589 8-8s-3.589-8-8-8a7.95 7.95 0 0 0-5.666 2.353.5.5 0 1 1-.708-.706A8.94 8.94 0 0 1 14.02 3ZM10.5 15a.5.5 0 1 1 0 1h-5a.5.5 0 1 1 0-1h5Zm-7 0a.5.5 0 1 1 0 1h-2a.5.5 0 1 1 0-1h2Zm12.285-6.412.069.058 3 3a.5.5 0 0 1 .058.638l-.058.07-3 3a.5.5 0 0 1-.765-.638l.058-.07 2.146-2.146H9.5a.5.5 0 0 1-.09-.992l.09-.008h7.793l-2.146-2.147a.5.5 0 0 1 .638-.765ZM7.5 11.5a.5.5 0 1 1 0 1h-4a.5.5 0 1 1 0-1h4Zm3-3.5a.5.5 0 1 1 0 1h-5a.5.5 0 0 1 0-1h5Z"
      fillRule="evenodd"
    />
  </SvgIcon>
);

export default QuickOrder;
